(function() {
  function updateSKUMedia(variantId) {
    const el = document.querySelector('[id^="VariantSKUMedia-"]');
    if (!el) return;

    let allMedia = {};
    try { allMedia = JSON.parse(el.textContent); } catch(e) { return; }

    const images = allMedia[variantId];
    if (!images || images.length === 0) return;

    // 找产品主图 Splide（排除公告栏和其他 Splide）
    const splideList = document.querySelector('[id^="media_product"] .splide__list');
    if (!splideList) return;

    splideList.innerHTML = '';

    images.forEach((img, index) => {
      const li = document.createElement('li');
      li.className = 'splide__slide';
      li.setAttribute('x-slide-index', index);
      li.innerHTML = `
        <div class="media media--transparent">
          <img src="${img.src}" alt="${img.alt}" loading="lazy" style="width:100%;height:100%;object-fit:contain;">
        </div>
      `;
      splideList.appendChild(li);
    });

    const splideEl = splideList.closest('.splide');
    if (splideEl && splideEl.splide) {
      splideEl.splide.refresh();
    }
  }

  let lastVariant = new URLSearchParams(location.search).get('variant');

  setInterval(() => {
    const current = new URLSearchParams(location.search).get('variant');
    if (current && current !== lastVariant) {
      lastVariant = current;
      updateSKUMedia(current);
    }
  }, 300);

  document.addEventListener('DOMContentLoaded', () => {
    const initial = new URLSearchParams(location.search).get('variant');
    if (initial) updateSKUMedia(initial);
  });
})();
